import * as mutation from "./mutations-types";

export default {
  [mutation.SET_BRANCHES](state, branches) {
    state.branches = [...branches];
  }
};
